<template>
    <section class="hero-branding bg-cover" :style="bgImg" id="home">
        <div class="container-fluid container-fluid--cp-150">
            <div class="mt-200 hero-branding flex-style">
                <div class="display-flex width-100">
                    <img src="../assets/img_design/img/pc/top_main.png" >
                    <h4 class="heading">
                        <p>{{lan.key45[cur_lan]}}</p>
                        <p>{{lan.key46[cur_lan]}}</p>
                        <p>{{lan.key47[cur_lan]}}</p>
                    </h4>
                </div>            
                <div class="slider-button fixed-button mt-80 display-flex justify-content-space-between width-100">
                    <a :href="'https://cbre.creis.jp/#cur_lan='+cur_lan" class="ht-btn ht-btn-md">{{lan.key8[cur_lan]}}</a>
                    <a href="javascript:void(0)"  class="ht-btn ht-btn-md" @click="showvideo=1">{{lan.key9[cur_lan]}}</a>        
                    <a :href="sign_url" class="ht-btn ht-btn-md">{{lan.key10[cur_lan]}}</a>
                    <div class="pop-video" v-if="showvideo"> <div class='pop-content'>
                            <div class="close-pop" @click="showvideo=0">X</div>
                            <video width="100%" height="600" poster="https://cdn2.cbredata.com/creis/videos/CREIS_SERVICE_CoverPage.png" controls>
            <source :src="'https://cdn2.cbredata.com/creis/videos/CREIS_SERVICE_'+(cur_lan=='jp'?'JP':'EN')+'.mp4'" type="video/mp4">
          
        </video></div></div>
                </div>
            </div>
        </div>
        <div class="news-top" v-if="show==1"><div class="mcontent">{{lan.new_content[cur_lan]}}<br><button class="ht-btn ht-btn-md" @click="show=0">{{lan.close[cur_lan]}}</button></div></div>
    </section>
</template>

<script>
    export default {
        data (){
            return {
                show:1,
                showvideo:0,
                bgImg: {
                    backgroundImage: `url(${require('../assets/img_design/img/pc/top_bg.jpg')})`
                },
                cur_lan:localStorage.getItem('cur_lan') || 'jp',
                lan:JSON.parse(localStorage.getItem('creis_web_language_data')).data,
                sign_url:'',
            }
        },
        mounted() {
            let partform=location.href.indexOf('stage.creis.jp')>-1?'stage':'live';
            this.sign_url='https://auth.creis.jp/sign?language='+this.cur_lan+'&partform='+partform;
        
        },
        
    }
</script>

<style lang="scss" scoped>
    @import '../assets/scss/variabls.scss';
    @import '../assets/scss/elements/hero-branding.scss';
    .news-top{display: none;}
    @media only screen  and (max-width:768px){
        .hero-branding .display-flex img{display: none;}
        .hero-branding .display-flex{display: block;}
        .hero-branding .display-flex a{display: block;min-width:320px; width: 80%;margin:10px auto;}
        .news-top{display: block;width: 100%;height: 100%;position: fixed;top:0;left:0;z-index: 999;background: #fff;}
        .news-top .mcontent{width: 80%;text-align: center;margin:35% auto;}
    }

.video-play{cursor: pointer;}
.pop-video{position: fixed;top: 0;left: 0;background: rgba(0,0,0,0.9);z-index: 9998;width: 100%;height: 100%;}
.pop-content{margin: 50px auto; width: 78%;max-width: 1050px; height: 660px;padding: 1%;z-index: 9999;box-shadow: #666 0px 0px 8px; background: #fff;border-radius: 8px;}
.close-pop{float: right;margin-right: -5px;margin-top: -5px; width: 25px;height: 25px;border: 1px solid #000;color: #000;border-radius: 20px;text-align: center;line-height: 25px;}

</style>
